// Dependency-free on purpose: wire schemas that sit in the database schema's
// import graph read this pattern without loading the experiment registry.

/** The shape of an experiment version, e.g. `2.0.0` or `2.0.0-web`. */
export const EXPERIMENT_VERSION_PATTERN = /^[0-9]+(?:\.[0-9]+){1,2}(?:-[a-z0-9.-]+)?$/;

/** The longest experiment version. Columns that store a version reuse this bound. */
export const EXPERIMENT_VERSION_MAX_LENGTH = 120;
